import { inject, injectable } from 'inversify';
import HttpClient from 'src/features/http';
import { backendUrl } from 'src/config';
import {
  ApplyCouponParams,
  ApplyCouponResponse,
  DiscountCouponServiceInterface,
  GetCouponDetailParams,
  RemoveCouponParams,
} from './DiscountCouponService.types';
import { CartCoupon, CouponDetails } from 'src/types/common';

@injectable()
class DiscountCouponService implements DiscountCouponServiceInterface {
  @inject(HttpClient) private readonly client!: HttpClient;

  public async applyToCart({ accessToken, couponCode }: ApplyCouponParams) {
    const response = await this.client.getClient().post<ApplyCouponResponse>(
      `/cart/coupons/${couponCode}/apply-to-cart/`,
      {},
      {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${accessToken}` },
      }
    );

    return response;
  }

  public async removeFromCart({ accessToken, couponCode }: RemoveCouponParams) {
    const response = await this.client.getClient().post<CartCoupon>(
      `/cart/coupons/${couponCode}/remove-from-cart/`,
      {},
      {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${accessToken}` },
      }
    );

    return response;
  }

  public async getDetails({ couponCode, accessToken }: GetCouponDetailParams) {
    const response = await this.client
      .getClient()
      .get<CouponDetails>(`/cart/coupons/${couponCode}/`, {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${accessToken}` },
      });

    return response;
  }
}

export default DiscountCouponService;
